import React, { useState } from 'react';
import { Card, Button, Form } from "tabler-react";
import postObject from '../../lib/postObject';
import { useForm } from '../../lib/useForm';
import ImageUpload from '../../components/imageUpload';

const CountryCreateModal = ({ closeMainModal, reload }) => {
  const [data, handleChange] = useForm({
    name: '',
    countryCode: '',
    currency: '',
    pricePerKg: '',
    minTravelerReward: '',
    moveitFeesPercentageOfTheTravelerReward: ''
  });
  const [countryFlag, setCountryFlag] = useState('');
  const [saveLoading, setSaveLoading] = useState(false);
  const [error, setError] = useState('');

  const validateForm = () => {
    if (!data.name) {
      setError('Please enter country name');
      return false;
    }
    if (!data.countryCode) {
      setError('Please enter country code');
      return false;
    }
    if (!data.currency) {
      setError('Please enter currency');
      return false;
    }
    if (!data.pricePerKg) {
      setError('Please enter price per kg');
      return false;
    }
    if (!data.minTravelerReward) {
      setError('Please enter minimum traveler reward');
      return false;
    }
    if (!data.moveitFeesPercentageOfTheTravelerReward && data.moveitFeesPercentageOfTheTravelerReward !== 0) {
      setError('Please enter fees reward percentage');
      return false;
    }
    if (!countryFlag) {
      setError('Please select a country flag photo');
      return false;
    }
    return true;
  };

  const saveCountry = async () => {
    setError('');
    if (!validateForm()) return;

    try {
      setSaveLoading(true);
      await postObject('countries', { ...data, countryFlag });
      if (typeof reload === 'function') {
        reload();
      }
      closeMainModal();
    } catch (err) {
      setError('Failed to create country. Please try again.');
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title>Create Country</Card.Title>
        <Card.Options>
          <Button
            size="sm"
            icon="x"
            onClick={closeMainModal}
          />
        </Card.Options>
      </Card.Header>
      <Card.Body>
        {error && <div className="alert alert-danger">{error}</div>}
        <Form onSubmit={(e) => { e.preventDefault(); saveCountry(); }}>
          <Form.Input
            name='name'
            label='Name'
            placeholder='Enter country name'
            value={data['name']}
            onChange={handleChange}
            required
          />
          <Form.Input
            name='countryCode'
            label='Country Code'
            placeholder='Enter country code (ex. US, EG, SA)'
            value={data['countryCode']}
            onChange={handleChange}
            required
          />
          <Form.Input
            name='currency'
            label='Currency'
            placeholder='Enter currency (ex. USD, EGP, SAR)'
            value={data['currency']}
            onChange={handleChange}
            required
          />
          <Form.Input
            name='pricePerKg'
            label='Price Per Kg'
            type="number"
            min="0"
            step="0.01"
            placeholder='Enter price per kilogram'
            value={data['pricePerKg']}
            onChange={handleChange}
            required
          />
          <Form.Input
            name='minTravelerReward'
            label='Min Reward'
            type="number"
            min="0"
            step="0.01"
            placeholder='Enter minimum traveler reward'
            value={data['minTravelerReward']}
            onChange={handleChange}
            required
          />
          <Form.Input
            name='moveitFeesPercentageOfTheTravelerReward'
            label='Fees Reward'
            type="number"
            min="0"
            max="100"
            step="0.01"
            placeholder='Enter fees reward percentage'
            value={data['moveitFeesPercentageOfTheTravelerReward']}
            onChange={handleChange}
            required
          />

          <ImageUpload
            label="Country Flag Photo"
            required
            uploadText="Click here to upload country flag"
            alt="Country Flag Preview"
            onChange={(value) => setCountryFlag(value)}
          />
        </Form>
      </Card.Body>
      <Card.Footer>
        <div style={{ textAlign: 'right' }}>
          <Button
            color="primary"
            size="sm"
            className={`ml-2 ${saveLoading ? 'btn-loading' : ''}`}
            onClick={saveCountry}
            disabled={saveLoading}
          >
            Save
          </Button>
          <Button
            color="secondary"
            size="sm"
            className="ml-2"
            onClick={closeMainModal}
            disabled={saveLoading}
          >
            Cancel
          </Button>
        </div>
      </Card.Footer>
    </Card>
  );
};

export default CountryCreateModal;
